import { useState, useEffect } from "react";
import "./LoadingBar.css";
import LogoMain from "../../resources/images/logo.png";

const LoadingScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => setFadeOut(true), 500);
          setTimeout(() => onComplete(), 1000);
          return 100;
        }
        return prev + 4;
      });
    }, 50);

    return () => clearInterval(interval);
  }, [onComplete]);

  return (
    <div className={`loading-screen ${fadeOut ? "fade-out" : ""}`}>
      <img src={LogoMain} alt="Logo" className="loading-logo" />
      <div className="loading-bar">
        <div className="loading-bar-progress" style={{ width: `${progress}%` }} />
      </div>
      <p className="loading-percentage">{progress}%</p>
    </div>
  );
};

export default LoadingScreen;
